import { MessageCircle } from "lucide-react";

export const SUPPORT_WHATSAPP = "8439752920";
const LINK = `https://wa.me/91${SUPPORT_WHATSAPP}?text=${encodeURIComponent("Hi Taxmandi support, I need help with")}`;
export const SUPPORT_LINK = LINK;

export const WhatsAppSupport = () => (
  <a href={LINK} target="_blank" rel="noreferrer" aria-label="WhatsApp support" data-testid="whatsapp-support-button"
    className="fixed bottom-20 right-4 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:scale-105 lg:bottom-6 lg:right-6">
    <MessageCircle className="h-5 w-5" /><span className="hidden sm:inline">WhatsApp support</span>
  </a>
);

export const SupportLink = ({ className = "" }) => (
  <a href={LINK} target="_blank" rel="noreferrer" className={className} data-testid="footer-whatsapp-support-link">WhatsApp support: +91 {SUPPORT_WHATSAPP}</a>
);
